export default "__VITE_ASSET__CIzjdlrf__"